import styles from './PageProductValuePropositions.module.css';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import useSearchParamOrDefaultProps from '../hooks/useSearchParamOrDefaultProps.js';

function PageProductValuePropositionsBiographies({
  valuePropositionProductSku,
  subtitle,
  iconUrl,
  biographies,
}) {
  const { theme } = useSearchParamOrDefaultProps();

  return (
    <>
      <div
        className={classNames(styles.detailsWrapper, styles.biography, {
          [styles.proProductBackgroundColor]:
            theme === 'pro' ||
            (theme === 'allAccess' && valuePropositionProductSku === 'PRO'),
          [styles.investingClubProductBackgroundColor]:
            theme === 'investingClub' ||
            (theme === 'allAccess' &&
              valuePropositionProduct === 'investingClub'),
          [styles.allAccessProductBackgroundColor]:
            theme === 'allAccess' && valuePropositionProductSku === 'AllAccess',
          [styles.registeredOnlyProductBackgroundColor]:
            theme === 'registeredOnly' ||
            (theme === 'allAccess' &&
              valuePropositionProductSku === 'RegisteredOnly'),
        })}
      >
        {iconUrl && subtitle && (
          <div className={styles.subtitleWrapper}>
            <div className={styles.iconWrapper}>
              <img className={styles.icon} src={iconUrl} alt={subtitle} />
            </div>
            <h3 className={styles.subtitle}>{subtitle}</h3>
          </div>
        )}
        <div className={styles.biographyContainer}>
          {biographies.map(
            ({ bioSubtitle, bioName, biography, bioImgUrl }, i) => (
              <div
                className={styles.biographyItemContainer}
                key={`${bioName}_${i}`}
              >
                <div className={styles.biographyImgContainer}>
                  <img className={styles.biographyImg} src={bioImgUrl} />
                </div>
                <div className={styles.biographyItemTextContainer}>
                  <div className={styles.subtitle}>{bioSubtitle}</div>
                  <div className={styles.title}>{bioName}</div>
                  <div className={styles.description}>{biography}</div>
                </div>
              </div>
            ),
          )}
        </div>
      </div>
    </>
  );
}

PageProductValuePropositionsBiographies.propTypes = {
  valuePropositionProductSku: PropTypes.string,
  subtitle: PropTypes.string,
  iconUrl: PropTypes.string,
  biographies: PropTypes.arrayOf(
    PropTypes.shape({
      bioSubtitle: PropTypes.string,
      bioName: PropTypes.string,
      biography: PropTypes.string,
      bioImgUrl: PropTypes.string,
    }),
  ),
};

export default PageProductValuePropositionsBiographies;
